// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1YWpj","name":"Header_name__yVQLf","birthday":"Header_birthday__1QiSE","skeleton":"Header_skeleton__3VUh6"};